import React from 'react'

export type GettingStartedPublicProps = Record<string, never>
export const GettingStartedPublic = ({}: GettingStartedPublicProps) => {
  return (
    <section className="text-center mb-8" aria-labelledby="getting-started-heading">
      <h2 id="getting-started-heading" className="text-3xl font-semibold mb-8 text-foreground">
        Getting Started
      </h2>
      <div className="max-w-3xl mx-auto">
        <div className="space-y-3">
          <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
            <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-sm">
              1
            </div>
            <div className="min-w-0 text-left">
              <p className="font-medium text-base text-foreground">
                Purchase a License & Add Team Members
              </p>
              <p className="text-sm text-muted-foreground">
                Choose a subscription plan and give your team access to the package.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
            <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-sm">
              2
            </div>
            <div className="min-w-0 text-left">
              <p className="font-medium text-base text-foreground">Install the Package</p>
              <p className="text-sm text-muted-foreground">
                Follow the{' '}
                <a
                  href="https://react-native-google-signin.github.io/docs/install#package-manager-setup"
                  className="text-primary underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  installation instructions
                </a>
                .
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
            <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-sm">
              3
            </div>
            <div className="min-w-0 text-left">
              <p className="font-medium text-base text-foreground">Complete the Setup</p>
              <p className="text-sm text-muted-foreground">
                Integrate{' '}
                <a
                  href="https://react-native-google-signin.github.io/docs/one-tap"
                  className="text-primary underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Universal sign-in
                </a>{' '}
                in your app and you're done! 🚀
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
